<div class="top-section">
    <h6 class="heading mb-0">{{
        ss.t('todayKebabMenu_titleTopBar') }}</h6>
    <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
</div>

<div class="body-section position-relative">
    <div class="list-items-block">
        <div class="category-item ri-px-4 ri-py-4">
            <div class="flex justify-between">
                <button (click)="$event.stopPropagation();" class="outline-none">
                    <span class="ri-me-6 text-14-400 color-8 ">{{ ss.t('common_calendarView')
                        }}</span>
                </button>
                <app-input-toggle [signal]="showCalendarViewSignal" (toggle)="ss.updateView()"></app-input-toggle>

            </div>
        </div>
        <div class="category-item ri-px-4 ri-py-4">
            <div class="flex justify-between">
                <button (click)="$event.stopPropagation();" class="outline-none">
                    <span class="ri-me-6 text-14-400 color-8">{{ ss.t('todayKebabMenu_myGoal')
                        }}</span>
                </button>
                <app-input-toggle [signal]="showUserGoalSignal" (toggle)="ss.updateView()"></app-input-toggle>
            </div>
        </div>
        <div class="category-item ri-px-4 ri-py-4">
            <div class="flex justify-between">
                <button (click)="$event.stopPropagation();" class="outline-none"
                    [disabled]="viewSettings.showCalendarView()">
                    <span class="ri-me-6 text-14-400"
                        [ngClass]="viewSettings.showCalendarView() ? 'color-7' : 'color-8'">{{
                        ss.t('todayKebabMenu_hideCompletedItems') }}</span>

                </button>
                <app-input-toggle [signal]="hideCompletedItemsSignal" (toggle)="ss.updateView()"
                    [disabled]="viewSettings.showCalendarView()"></app-input-toggle>
            </div>
        </div>
        <div class="category-item ri-px-4 ri-py-4">
            <div class="flex justify-between"> <button (click)="$event.stopPropagation();" class="outline-none"
                    [disabled]="viewSettings.showCalendarView() || viewSettings.entityGroupBy() === 'category'">
                    <span class="ri-me-6 text-14-400"
                        [ngClass]="viewSettings.showCalendarView() || viewSettings.entityGroupBy() === 'category' ? 'color-7' : 'color-8'">{{
                        ss.t('todayKebabMenu_timeline') }}</span>

                </button>
                <app-input-toggle [signal]="showTimeboxSignal" (toggle)="ss.updateView()"
                    [disabled]="viewSettings.showCalendarView() || viewSettings.entityGroupBy() === 'category'"></app-input-toggle>
            </div>
        </div>
        <div class="category-item ri-px-4 ri-py-4" *ngIf="showInvalidEntryToggle()">
            <div class="flex justify-between">
                <button (click)="$event.stopPropagation();" class="outline-none">
                    <span class="ri-me-6 text-14-400 color-8">{{ ss.t('viewConfiguration_invalidEntry') }}</span>
                </button>
                <app-input-toggle [signal]="invalidEntryToggle" (toggle)="toggleInvalidEntry()"></app-input-toggle>
            </div>
        </div>
        <div class="category-item ri-px-4 ri-py-4 flex items-center">
            <div class="flex justify-between w-full items-center">
                <button (click)="$event.stopPropagation();" class="outline-none"
                    [disabled]="viewSettings.showCalendarView()">
                    <span class="ri-me-6 text-14-400"
                        [ngClass]="viewSettings.showCalendarView() ? 'color-7' : 'color-8'">{{
                        ss.t('common_groupBy') }}</span>
                </button>
                <app-input-dropdown [signal]="entityGroupBySignal" [config]="vs.entityGroupByConfig()"
                    [hiddenValues]="['date', 'hashtag', 'mood', 'transactionType', 'setup']" (select)="ss.updateView()"
                    textClass="text-16-400 whitespace-nowrap" [hideDropdown]="viewSettings.showCalendarView()"
                    [ngClass]="viewSettings.showCalendarView() ? 'opacity-50' : 'color-'"></app-input-dropdown>
            </div>


        </div>
        <div class="category-item ri-px-4 ri-py-4">
            <button (click)="$event.stopPropagation()" class="outline-none"
                [disabled]="viewSettings.showCalendarView()">
                <app-kebab-show-menu [hideDialog]="viewSettings.showCalendarView()"
                    textClass="text-16-400 leading-[22px]" [signal]="entityShowSignal" [config]="vs.entityShowConfig()"
                    [multiple]="true" (select)="ss.updateView()" (selectNested)="ss.updateView()"
                    [hiddenValues]="hiddenValues()" [notApplicableValues]="notApplicableValues()"
                    [colorClass]="viewSettings.showCalendarView() ? 'color-10' : 'color-35'"
                    [placeholder]="ss.t('common_kebabMenuViewConfiguration')"
                    [placeholderColor]="viewSettings.showCalendarView() ? 'color-7' : 'color-8'"
                    [kebabShowPanelClass]="cc.isNarrowScreen() ? 'commonbottomSheetClass' : ''"></app-kebab-show-menu>

            </button>
        </div>
    </div>
</div>